// extracted by mini-css-extract-plugin
export default {"e_create_user":"create-user_e_create_user__dzMPX","e_dialog":"create-user_e_dialog__MNWIr"};